'use client'

import { Building2, ChevronsUpDown, Eye, LogOut, User } from 'lucide-react'
import { useState } from 'react'

import { Link } from 'react-router-dom'
import { ImpersonateUserDialog } from '~/components/ImpersonateUserDialog/ImpersonateUserDialog'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '~/components/ui/dropdown-menu'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '~/components/ui/sidebar'
import { useAuth } from '~/hooks/useAuth'
import { ICompany } from '~/utils/types'

export function NavUser() {
  const { identity, handleLogout, user, canImpersonate } = useAuth()
  const { isMobile } = useSidebar()
  const workspaceName = (user?.company as ICompany)?.name
  const [impersonateOpen, setImpersonateOpen] = useState(false)

  return (
    <>
      <SidebarMenu>
        <SidebarMenuItem>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <SidebarMenuButton
                size='lg'
                className='data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground'
              >
                <div className='grid flex-1 text-left text-sm leading-tight'>
                  <span className='truncate font-semibold'>{workspaceName ?? 'Workspace'}</span>
                  <span className='truncate text-xs'>{identity?.email}</span>
                </div>
                <ChevronsUpDown className='ml-auto size-4' />
              </SidebarMenuButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className='w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg'
              side={isMobile ? 'bottom' : 'right'}
              align='end'
              sideOffset={4}
            >
              <DropdownMenuGroup>
                <Link to='/account'>
                  <DropdownMenuItem>
                    <User />
                    Your account
                  </DropdownMenuItem>
                </Link>
              </DropdownMenuGroup>
              <DropdownMenuSeparator />
              <DropdownMenuGroup>
                <Link to='/auth/change-workspace'>
                  <DropdownMenuItem>
                    <Building2 />
                    Change workspace
                  </DropdownMenuItem>
                </Link>
              </DropdownMenuGroup>
              {canImpersonate && (
                <>
                  <DropdownMenuSeparator />
                  <DropdownMenuGroup>
                    <DropdownMenuItem onClick={() => setImpersonateOpen(true)}>
                      <Eye />
                      [ADMIN] Impersonate user
                    </DropdownMenuItem>
                  </DropdownMenuGroup>
                </>
              )}
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={handleLogout}>
                <LogOut />
                Log out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </SidebarMenuItem>
      </SidebarMenu>
      <ImpersonateUserDialog open={impersonateOpen} onOpenChange={setImpersonateOpen} />
    </>
  )
}
